import { render, staticRenderFns } from "./OrdersSummaryByAffiliate.vue?vue&type=template&id=4b481418&scoped=true"
import script from "./OrdersSummaryByAffiliate.vue?vue&type=script&lang=js"
export * from "./OrdersSummaryByAffiliate.vue?vue&type=script&lang=js"
import style0 from "./OrdersSummaryByAffiliate.vue?vue&type=style&index=0&id=4b481418&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b481418",
  null
  
)

export default component.exports